import React, { Component } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import NorseMythology from "../pages/NorseMythology";
import TokyoMap from "./TokyoMap";

export default class Main extends Component {
  render() {
    return (
      <Routes>
        {/* The Switch decides which component to show based on the current URL.*/}

        <Route path="/" element={<Home />} />
        <Route path="/tokyo" element={<TokyoMap />}></Route>
        <Route exact path="/NorseMythology" component={NorseMythology}></Route>
      </Routes>
    );
  }
}
